export default __webpack_public_path__ + "static/media/main-img.d3426125.png";